import { render, staticRenderFns } from "./GeneralDataTable.vue?vue&type=template&id=51842635&"
import script from "./GeneralDataTable.vue?vue&type=script&lang=js&"
export * from "./GeneralDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports